<template>
  <div class="col-span-2 sm:col-span-2">
    <div class="relative">
      <div class="absolute inset-0 flex items-center" aria-hidden="true">
        <div class="w-full border-t border-gray-300" />
      </div>
      <div class="relative flex justify-start">
        <span class="pr-3 bg-light-grey text-lg font-medium text-vice-teal-700">Past sessions</span>
      </div>
    </div>

    <div class="flex flex-col mt-8" v-if="pastSessionsExist">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="shadow-sm overflow-hidden border border-gray-200 sm:rounded-lg">
            <table class="table-fixed min-w-full divide-y divide-gray-50">
              <thead>
                <tr class="border-b border-gray-200">
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xxs font-medium text-gray-500 tracking-wider"
                  >
                    Title
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xxs font-medium text-gray-500 tracking-wider"
                  >
                    Date
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-center text-xxs font-medium text-gray-500 tracking-wider"
                  >
                    Start
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-center text-xxs font-medium text-gray-500 tracking-wider"
                  >
                    Total duration
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-center text-xxs font-medium text-gray-500 tracking-wider"
                  >
                    Attendees
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-center text-xxs font-medium text-gray-500 tracking-wider"
                  >
                    Access
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(session, sessionIdx) in this.$page.props.sessions.past_sessions"
                  :key="session.unique_id"
                  :class="sessionIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                >
                  <td class="px-6 py-4 text-xs font-medium text-vice-teal-900">
                    <span
                      class="cursor-pointer"
                      @click="Inertia.visit(route('session.clinician.details', session.unique_id))"
                    >
                      {{ session.title }}
                    </span>
                  </td>
                  <td class="px-6 py-4 text-left whitespace-nowrap text-xs text-gray-500">
                    {{ yearFormatter(session.details.session_start_by_timezone) }}
                  </td>
                  <td class="px-6 py-4 text-center whitespace-nowrap text-xs text-gray-500">
                    {{ hoursFormatter(session.details.session_start_by_timezone) }}
                  </td>
                  <td class="px-6 py-4 text-center whitespace-nowrap text-xs text-gray-500">
                    {{ durationFormatter(session.analytics?.total_duration || 0) }}
                  </td>
                  <td class="px-6 py-4 flex justify-center">
                    <ViceBadge
                      :amount="session.total_participants"
                      icon="UserIcon"
                      :indigo="session.total_participants > 0"
                      :gray="session.total_participants == 0"
                    />
                    <ViceBadge
                      :amount="session.total_observers"
                      icon="EyeIcon"
                      class="ml-4"
                      :yellow="session.total_observers > 0"
                      :gray="session.total_observers == 0"
                    />
                  </td>
                  <td class="px-6 py-4 text-center">
                    <GroupOfPeopleIcon class="inline-block" v-if="!session.is_private" />
                    <LockIcon class="inline-block" v-if="session.is_private" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8 text-gray-500 text-center" v-else>
      Sessions in which you participated will appear here.
    </div>
  </div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia';
import DateFormatMixin from '@/Mixins/DateFormatMixin.vue';
import ViceBadge from '@/Components/Badges/ViceBadge.vue';
import GroupOfPeopleIcon from '@/Components/Icons/GroupOfPeopleIcon.vue';
import LockIcon from '@/Components/Icons/LockIcon.vue';

export default {
  name: 'PastSessions',
  setup() {
    return {
      userType,
    };
  },
  components: {
    LockIcon,
    GroupOfPeopleIcon,
    ViceBadge,
  },
  mixins: [DateFormatMixin],
  computed: {
    Inertia() {
      return Inertia;
    },
    pastSessionsExist() {
      return Object.keys(this.$page.props.sessions.past_sessions).length;
    },
  },
};
</script>
